import React from "react";
import { IconCheckmark, IconMinus } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { Checkbox as Checkbox$1 } from "@base-ui/react/checkbox";
import { useController, useFormContext } from "react-hook-form";
//#region src/Checkbox/index.tsx
/**
* Checkbox из нового UI Kit'a.
* Дизайн - https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q/%D0%90%D1%81%D1%83%D0%B1%D0%B8%D0%BC.-%D0%A0%D0%96%D0%94-UI-Kit?node-id=417%3A5616&t=qviLsjVfuJYMQbnQ-0
*/
function Checkbox(props) {
	if (props.control && props.name && props.value) return /* @__PURE__ */ jsx(CheckboxControlled, {
		...props,
		control: props.control,
		name: props.name,
		value: props.value
	});
	return /* @__PURE__ */ jsx(CheckboxBase, { ...props });
}
const CheckboxBase = React.memo(({ checked, label, disabled, onChange, name, value, size = "md", className, ...rest }) => {
	const checkedBool = checked === void 0 ? void 0 : checked === true;
	const indeterminate = checked === "indeterminate";
	const uniqueId = React.useId();
	const fieldId = `${name ?? "checkbox"}_${value ?? "value"}_${uniqueId}`;
	return /* @__PURE__ */ jsxs("div", {
		className: cn("flex items-start gap-2", className),
		children: [/* @__PURE__ */ jsx(Checkbox$1.Root, {
			"data-cy": "checkbox-container-tasktracker",
			id: fieldId,
			className: cn(rootBaseClassName, checkboxSizeClassName[size], "focus-visible:outline-system-info-70 outline-offset-0 focus-visible:outline", disabled && "!border-neutrals-80 !bg-neutrals-80"),
			checked: checkedBool,
			indeterminate,
			disabled,
			onCheckedChange: onChange,
			...rest,
			children: /* @__PURE__ */ jsxs(Checkbox$1.Indicator, {
				keepMounted: true,
				className: indicatorClassName,
				children: [checked !== "indeterminate" && /* @__PURE__ */ jsx(IconCheckmark, { className: cn("shrink-0 text-white", iconCheckClassName[size]) }), checked === "indeterminate" && /* @__PURE__ */ jsx(IconMinus, { className: cn("shrink-0 text-white", iconMinusClassName[size]) })]
			})
		}), label && /* @__PURE__ */ jsx("label", {
			className: cn("min-w-0 cursor-pointer truncate text-gray-900", labelSizeClassName[size]),
			htmlFor: fieldId,
			children: label
		})]
	});
});
CheckboxBase.displayName = "CheckboxBase";
const CheckboxControlled = ({ name, value, control, checked, onChange, ...rest }) => {
	const { field } = useController({
		name,
		control
	});
	const { getValues } = useFormContext();
	const handleChange = () => {
		const valueCopy = [...getValues(name) ?? []];
		if (valueCopy.includes(value)) valueCopy.splice(valueCopy.indexOf(value), 1);
		else valueCopy.push(value);
		field.onChange(valueCopy);
		onChange?.(checked);
	};
	const fieldValue = field.value;
	return /* @__PURE__ */ jsx(CheckboxBase, {
		...rest,
		name,
		value,
		checked: fieldValue?.includes(value),
		onChange: handleChange
	});
};
const checkboxSizeClassName = {
	sm: "size-4",
	md: "size-5"
};
const labelSizeClassName = {
	sm: "text-xs leading-6",
	md: "text-base leading-6"
};
const iconCheckClassName = {
	sm: "size-3",
	md: "size-4"
};
const iconMinusClassName = {
	sm: "size-3",
	md: "size-4"
};
const rootBaseClassName = "border-neutrals-80 bg-neutrals-95 [&[data-checked]]:border-brand-40 [&[data-checked]]:bg-brand-40 [&[data-checked][data-disabled]]:!border-neutrals-70 [&[data-checked][data-disabled]]:!bg-neutrals-70 [&[data-indeterminate]]:border-brand-40 [&[data-indeterminate]]:bg-brand-40 [&[data-indeterminate][data-disabled]]:!border-neutrals-70 [&[data-indeterminate][data-disabled]]:!bg-neutrals-70 box-border mt-0.5 flex shrink-0 items-center justify-center rounded-[3px] border-2 outline-none transition-colors duration-[25ms]";
const indicatorClassName = "hidden size-full [&[data-checked]]:flex [&[data-checked]]:items-center [&[data-checked]]:justify-center [&[data-indeterminate]]:flex [&[data-indeterminate]]:items-center [&[data-indeterminate]]:justify-center";
//#endregion
export { Checkbox, CheckboxBase };

//# sourceMappingURL=index.js.map